import { DerivativeWallet } from "./derivative_wallet";
import { TYPE_NAME_EQUITY_ETF } from "@helpers/constants";

export class EquityETFWallet extends DerivativeWallet {
	public static TypeName: string = TYPE_NAME_EQUITY_ETF;
}
